import React from 'react';

import MembershipCard from 'shared/components/membership-card/membership-card';
import type { NamedFC } from 'shared/types/named-fc.types';

import Layout from 'ui/components/layout/layout';

import type { ChooseMembership as Props } from './choose-membership.props';

const ChooseMembership: NamedFC<Props> = ({ layout, memberships }) => {
  return (
    <Layout {...layout}>
      <div className="choose-membership">
        <div className="choose-membership__memberships">
          {memberships.map(membership => (
            <MembershipCard key={membership.id} {...membership} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

ChooseMembership.displayName = 'ChooseMembership';

export default ChooseMembership;
